import { ReturnBaseUrl } from '@/network/request'

export function identity() {
  return [
    ReturnBaseUrl(),
    sessionStorage.getItem('userId'),
    sessionStorage.getItem('token')
  ].join('|')
}
export function requestId() {
  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)
  return Array.from(bytes, x => x.toString(16).padStart(2, '0')).join('')
}
